import { render, staticRenderFns } from "./ResignTemplate.vue?vue&type=template&id=0e44ded6"
import script from "./ResignTemplate.vue?vue&type=script&lang=js"
export * from "./ResignTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports